/**
 * Possible values of 'environment' field registered in FUSRA enum
 * WARNING! Before the change, create a task in the FUS project
 *
 * https://youtrack.jetbrains.com/issues/FUS
 */
export enum Page {
	Help = 'Help',
	Invitation = 'Invitation',
	AgreementDeclined = 'AgreementDeclined',
	Main = 'Main',
	NotPersonalOrganization = 'NotPersonalOrganization',
	PersonalOrganization = 'PersonalOrganization',
	Report = 'Report',
	Team = 'Team',
	Welcome = 'Welcome',
	Agreement = 'Agreement', // https://youtrack.jetbrains.com/issue/FUS-1759/Update-group-cloudpages
	Maintenance = 'Maintenance', // https://youtrack.jetbrains.com/issue/FUS-1759/Update-group-cloudpages
	Onboarding = 'Onboarding', // https://youtrack.jetbrains.com/issue/FUS-1894/Update-group-cloudpages
	NoMatch = 'NoMatch', // https://youtrack.jetbrains.com/issue/FUS-2081/Update-group-cloud.pages,
	AgreementReviewPage = 'AgreementReviewPage', // https://youtrack.jetbrains.com/issue/FUS-2127/Update-group-cloud.pages
	Profile = 'Profile', // https://youtrack.jetbrains.com/issue/FUS-2210/Update-group-cloud.pages
	OrganizationSettings = 'OrganizationSettings', // https://youtrack.jetbrains.com/issue/FUS-2210/Update-group-cloud.pages
}
